import { useEffect, useCallback } from 'react';
import NextArrow from 'components/Arrows/NextArrow';
import PrevArrow from 'components/Arrows/PrevArrow';
import NewsletterHero from 'components/NewsletterHero';
import type { Newsletter } from 'interfaces/Account';
import Slider from 'react-slick';
import NEWSLETTERS_SECTION_TEST_IDS from 'constants/testsIds/newslettersPage';
import SliderWraper from './NewsletterCarouselStyles';

export interface NewsletterCarouselProps {
  newsletterHeroes: Newsletter[];
  className?: string;
  onClick: (news: Newsletter) => () => void;
}

const NewsletterCarousel = ({ newsletterHeroes, className = '', onClick }: NewsletterCarouselProps) => {
  const updateTabIndex = useCallback(() => {
    document.querySelectorAll('.slick-slider button, .slick-slider a').forEach((el) => {
      const isHidden = el.closest('[aria-hidden="true"]');
      el.setAttribute('tabindex', isHidden ? '-1' : '0');
    });
  }, []);

  const settings = {
    afterChange: updateTabIndex,
    className: '',
    dots: true,
    infinite: false,
    nextArrow: <NextArrow ariaLabel='Next Carousel Newsletters' />,
    prevArrow: <PrevArrow ariaLabel='Previous Carousel Newsletters' />,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
  };

  useEffect(() => {
    updateTabIndex();
  }, [updateTabIndex, newsletterHeroes]);

  return (
    <SliderWraper
      data-cy={NEWSLETTERS_SECTION_TEST_IDS.SLIDER_WRAPPER}
      className={className}
    >
      <Slider
        data-cy={NEWSLETTERS_SECTION_TEST_IDS.SLIDER_STICK}
        {...settings}
      >
        {newsletterHeroes.length > 0 &&
          newsletterHeroes.map((newsletter) => (
            <NewsletterHero
              data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_HERO}
              key={newsletter.formName}
              className='newsletter'
              newsletter={newsletter}
              onClick={onClick}
            />
          ))}
      </Slider>
    </SliderWraper>
  );
};

export default NewsletterCarousel;
